export enum Flows {
  FULL = 'full',
  FASTTRACK = 'fasttrack',
  INITIAL = 'initial',
  BIG = 'big',
  BIG_INITIAL = 'biginitial',
  TM_SIGN_UP = 'tmsignup',
  TM_AUTH = 'tmauth',
}

export enum Countries {
  FINLAND = 'fi',
  NETHERLANDS = 'nl',
  SWEDEN = 'se',
}

export enum TicketType {
  BIG = 'BIG',
}

// API endpoints

////////////////////////////////////////
////////////////////  Authentication
////////////////////////////////////////
export const VERIFY_ID = '/login/verifyid';
export const VERIFY_SESSION = '/login/verifysession';
export const VERIFY_USER = '/login/verifyuser';
export const VERIFY_TOKEN = '/login/verifytoken';
export const VERIFY_WEAK = '/login/verifyweak';

////////////////////////////////////////
////////////////////  Company
////////////////////////////////////////
export const COMPANY = '/company';
export const COMPANY_ENGAGEMENTS = '/company/engagements/';
export const COMPANY_LOOKUP = '/company/lookup';
export const COMPANY_SEARCH = '/company/search';
export const UPDATE_COMPANY = '/company';

////////////////////////////////////////
////////////////////  Lead
////////////////////////////////////////
export const LEAD = '/contacts/lead';

////////////////////////////////////////
////////////////////  Contacts
////////////////////////////////////////
export const CONTACTS = '/contacts';

////////////////////////////////////////
////////////////////  Applications
////////////////////////////////////////
export const APPLICATIONS = '/applications';
export const UPDATE_APPLICATION = '/applications';
export const ADD_ASSET_TO_APPLICATION = '/applications';
export const SUBMIT_APPLICATION = '/applications';
export const ASSETS = '/assets';
export const ASSET_NAME = {
  ACCOUNT_DATA: 'AS',
  BALANCE: 'BR',
  PROFIT_AND_LOSS: 'RR',
  REAL_ESTATE: 'RE',
  OTHER: 'OF',
};
export const GENERIC_FILE_PREFIX = {
  MT940: 'gfu_MT940_',
};

export const SECURITIES = '/securities';

////////////////////////////////////////
////////////////////  Klarna
////////////////////////////////////////
export const KLARNA_SESSION_START = '/klarna/session/start';
export const KLARNA_SESSION_COMPLETE = '/klarna/session/complete';
export const KLARNA_SESSION_TERMINATE = '/klarna/session/terminate';

////////////////////////////////////////
////////////////////  Files
////////////////////////////////////////
export const FILES = '/files';
export const FILES_APPLICATION = `${FILES}/application`;

////////////////////////////////////////
////////////////////  Reseller
////////////////////////////////////////
export const RESELLER = '/reseller';

////////////////////////////////////////
////////////////////  IDIN
////////////////////////////////////////
export const IDIN_DIRECTORY = '/idin/directory';
export const IDIN_VERIFYID = '/idin/verifyid';
export const IDIN_STATUS = '/idin/status';

////////////////////////////////////////
////////////////////  UNSUBSCRIBE
////////////////////////////////////////
export const UNSUBSCRIBE_SMS = '/sms/unsubscribe';

// Error messages
export const APPLICATION_ALREADY_OPEN =
  'The user has an open application, cannot create a new one.';
